import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import styles from "./AccountIssueList.module.css";
import AccountIssueItem from "components/AccountIssueItem";
import VerifyIcon from "../../VerifyPopUp/Verify_Header.svg";
import CreditCardICon from "assets/Credit_Card_Icon.svg";
import PremierIcon from "assets/Premier_Membership_Icon.svg";
import AccountIcon from "assets/account_icon.png";
import EventIcon from "assets/FE_ticket_event.svg";
import mobile from "mobileBridge";
import environment from "environment";
import { NavigationSvc } from "../../navigationScv";
import { useAccount } from "utils/AccountInfoContext"; // Import useAccount
import Button from "components/Button";
import { useTranslation } from "react-i18next";

export function AccountIssueList({ issues, category, onAddClick }) {
  const {t} = useTranslation();
  const navigationSvc = new NavigationSvc();
  const history = useHistory();
  const { consentData } = useAccount(); // Get consentData from useAccount

  const getIconCategory = (category) => {
    switch (category) {
      case "Verifications":
        return VerifyIcon;
      case "Billing Issues":
        return CreditCardICon;
      case "Event Issues":
        return EventIcon;
      case "Membership Issues":
      case "Premier Issues":
        return PremierIcon;
      case "Personal Account Issues":
        return AccountIcon;
      default:
        return "";
    }
  };

  const buttonTextMap = {
    Verifications: "Verify",
    "Personal Account Issues": "Add",
    "Billing Issues": "Help",
    "Event Issues": "Help",
    "Membership Issues": "Help",
  };

  const getEventButtonText = (issue) => {
    switch (issue.Type) {
      case "event-spring-leadership-payment":
        return "View Spring Leadership Orders";
      case "event-free-enterprise-payment":
        return "View Free Enterprise Orders";
      case "event-family-reunion-payment":
        return "View Family Reunion Orders";
      default:
        return "Help";
    }
  };

  const getButtonText = (issue, category) => {
    const resolveIssues = [
      "membership-primary-billing-cc-missing",
      "membership-cancelled",
      "membership-suspended",
      "membership-expired",
      "credit-card-expired",
      "credit-card-expiring",
    ];

    if (resolveIssues.includes(issue.Type)) {
      return "Resolve";
    }

    if (issue.Type === "membership-primary-billing-ach-missing") {
      return "Help";
    }

    return category === "Event Issues"
      ? getEventButtonText(issue)
      : buttonTextMap[category] || "Help";
  };

  const handleOnClick = (issue, buttonText) => {
    if (buttonText === "Resolve") {
      switch (issue.Type) {
        case "credit-card-expired":
        case "credit-card-expiring":
        case "membership-primary-billing-cc-missing":
          history.push("/credit-cards");
          break;
        case "membership-suspended":
        case "membership-cancelled":
        case "membership-expired":
          history.push("/membership");
          break;
        default:
          if (mobile.isApp()) {
            navigationSvc.goToApp("help", {});
          } else {
            window.location.href = environment.helpUrl;
          }
      }
      return;
    }

    if (buttonText === "Help") {
      if (mobile.isApp()) {
        navigationSvc.goToApp("help", {});
      } else {
        window.location.href = environment.helpUrl;
      }
      return;
    }

    if (onAddClick && buttonText === "Add") {
      onAddClick(issue.Type);
      return;
    }

    if (buttonText === "Verify") {
      switch (issue.Type) {
        case "phone-unverified":
        case "email-unverified":
        case "address-unverified":
          history.push("/verify");
          break;
        default:
          history.push("/");
      }
      return;
    }

    if (buttonText.includes("View")) {
      if (mobile.isApp()) {
        navigationSvc.goToApp("receipts", {});
      } else {
        window.location.href = environment.receiptsUrl;
      }
      return;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img
          src={getIconCategory(category)}
          alt={"Category Icon"}
          className={styles.icon}
        />
        <span className={styles.category}>{t(category)}</span>
      </div>
      {issues &&
        issues.map((issue, index) => (
          <AccountIssueItem
            key={index}
            label={issue.label}
            message={issue.message}
            buttonText={getButtonText(issue, category)}
            onClick={() => handleOnClick(issue, getButtonText(issue, category))}
          />
        ))}{" "}
    </div>
  );
}

AccountIssueList.propTypes = {
  category: PropTypes.string.isRequired,
  onAddClick: PropTypes.func.isRequired,
};

export default AccountIssueList;
